var imgSlider = {
    init:function(target){		
		var img_slider = $(target + ' .img-slider-content .img-slider-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:false,
			dots: false,
			arrows:false,
			nav:false
		});
		$(target + ' .img-slider-content .left').click(function(){
			img_slider.slick('slickPrev');
			return false;
		});
		$(target + ' .img-slider-content .right').click(function(){
			img_slider.slick('slickNext');
			return false;
		});	
    }
};

var imgDetailsSlider = {
    init:function(target){		
		var img_details_slider = $(target + ' .grid').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			dots: false,
			arrows:false,
			nav:false,
			responsive: [
			    {
			      breakpoint: 1200,
			      settings: {
			        arrows: false,
					//centerPadding: '40px',
			        slidesToShow: 3,
					centerMode: true,
			      }
			    }, 
			    {
			      breakpoint: 767,
			      settings: {
						arrows: false,
						centerPadding: '40px',
						slidesToShow: 2,
					  centerMode: false,
			      }
			    },
				 {
			      breakpoint: 600,
			      	settings: {
					arrows: false,
					centerPadding: '30px',
					slidesToShow: 1,
				  	centerMode: true,
			      }
			    },
				 {
			      breakpoint: 380,
			      settings: {
                    arrows: false,
                    centerPadding: '30px',
                    slidesToShow: 1,
					centerMode: true,
			      }
			    }
			]
		});
    }
};
 

var videoPost = {
	init:function(){
		$('video').each(function(){			
			$(this).mediaelementplayer({			
				mode: 'shim',
			    videoWidth: 1600,
			    videoHeight: 900,
			    plugins: ['flash','silverlight'],
			    features: ['playpause', 'progress', 'current', 'tracks', 'fullscreen'],
			    pauseOtherPlayers: true
			});
		});
		  
	}

    /*init:function(){
		var video = $('video');
		var videoElement = video.get(0);		
		$('.article-video .icon_play').click(function(){
			videoElement.play();
		});
		video.bind("pause", function() {
		   videoPost.videoStoped();
		});
		video.bind("ended", function() {
		   videoPost.videoStoped();
		});
		video.bind("playing", function() {
			videoPost.videoPlaying();
		});
	},
	videoStoped: function(){
		$('.article-video').addClass('stoped');
	},
	videoPlaying: function(){
		$('.article-video').removeClass('stoped');
	}*/
};




var imgSlider2 = {
   init:function(target){
		$(target + ' .img-slider-content .img-slider-carousel').on('init',function(){
			$('.featured-blog').removeClass('loading');
		});

		var img_slider_2 = $(target + ' .img-slider-content .img-slider-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:false,
			arrows:false
		});
	   
		img_slider_2.on('afterChange', function(){
			var index = Number($(target + ' .img-slider-content .slick-slide.slick-active').data('slick-index'))+1;
			if(index < 10){
				index = "0" + index;
			}
			$(target + ' .arrows-pagination .left span').html(index);
		});

		$(target + ' .arrows-pagination .left').click(function(){
			img_slider_2.slick('slickPrev');
			return false;
		});
		$(target + ' .arrows-pagination .right').click(function(){
			img_slider_2.slick('slickNext');
			return false;
		});
	}
};


var imgSlider3 = {
    init:function(target){
		var img_slider3 = $(target + ' .img-slider-content .img-slider-carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:false,
			dots: false,
			arrows:false,
			nav:false
		});
		$(target + ' .img-slider-content .left').click(function(){
			img_slider3.slick('slickPrev');
			return false;
		});
		$(target + ' .img-slider-content .right').click(function(){
			img_slider3.slick('slickNext');
			return false;
		});	
    }
};
